import { platformSelect } from "../../utils/platformUtils"
import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'
import { he } from 'date-fns/locale'

const { width, height } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
        alignItems: 'center',
        justifyContent: 'center',
    },
    containerInfo: {
        paddingTop: 12,
        paddingHorizontal: 10,
        paddingBottom: 15,
        alignSelf: 'center',
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center',
        color: 'white',
        marginVertical: 5,
    },
    description: {
        fontSize: 15,
        fontWeight: 'normal',
        textAlign: 'center',
        color: 'white',
    },
    image: {
        position: 'absolute',
        width: width * 0.8,
        height: width * 0.8,
        top: height / 2 - width * 0.4,
        left: width / 2 - width * 0.4,
        resizeMode: 'stretch',
    },
    imageAsset: {
        width: 70,
        height: 70,
    },
    titleText: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 25,
    },
    descriptionText: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 25,
    },
    buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        paddingTop: 12,
        paddingHorizontal: 12,
    },
    mainButton: {
        width: '100%',
        height: 40,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 5,
    },
    mainButtonText: {
        fontSize: 15,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    containerCamera: {
        flex: 1,
        width: width,
        height: 'auto',
        backgroundColor: platformSelect({
            android: 'black',
            ios: 'transparent',
            default: 'transparent',
        }),
    },
    camera: {
        width: width,
        height: height,
        position: 'absolute',
        resizeMode: 'cover',
        flex: 1,
    },
    overlay: {
        ...StyleSheet.absoluteFill,
        marginTop: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    borderVertical: {
        position: 'absolute',
        borderWidth: 1,
        borderColor: 'white',
        backgroundColor: 'white',
        width: 2,
        height: 60,
    },
    borderHorizontal: {
        position: 'absolute',
        borderWidth: 1,
        borderColor: 'white',
        backgroundColor: 'white',
        width: 60,
        height: 2,
    },
    topLeft: {
        top: 200,
        left: platformSelect({
            android: 60,
            ios: 40,
            default: 40,
        }),
    },
    topRight: {
        top: 200,
        right: platformSelect({
            android: 60,
            ios: 40,
            default: 40,
        }),
    },
    bottomLeft: {
        bottom: 200,
        left: platformSelect({
            android: 60,
            ios: 40,
            default: 40,
        }),
    },
    bottomRight: {
        bottom: 200,
        right: platformSelect({
            android: 60,
            ios: 40,
            default: 40,
        }),
    },
})

export default styles
